function SeedanceLogo() {
  return (
    <svg
      height="20"
      width="20"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.944 18.587l-1.704-.445V10.01l1.824-.462c1-.254 1.84-.461 1.88-.453.032 0 .056 2.235.056 4.972v4.973l-.176-.008c-.104 0-.952-.207-1.88-.446z"
        fill="#00C8D2"
        fillRule="nonzero"
      />
      <path
        d="M7 16.542c0-2.736.024-4.98.064-4.98.032-.008.872.2 1.88.454l1.816.461-.016 4.05-.024 4.049-1.632.422c-.896.23-1.736.445-1.856.469L7 21.523v-4.98z"
        fill="#3C8CFF"
        fillRule="nonzero"
      />
      <path
        d="M19.24 12.477c0-9.03.008-9.515.144-9.475.072.024.784.207 1.576.406.792.207 1.576.405 1.744.445l.296.08-.016 8.56-.024 8.568-1.624.414c-.888.23-1.728.437-1.856.47l-.24.055v-9.523z"
        fill="#78E6DC"
        fillRule="nonzero"
      />
      <path
        d="M1 12.509c0-4.678.024-8.505.064-8.505.032 0 .872.207 1.872.454l1.824.461v7.582c0 4.16-.016 7.574-.032 7.574-.024 0-.872.215-1.88.47L1 21.013v-8.505z"
        fill="#325AB4"
      />
    </svg>
  );
}

export const banner = {
  text: "Get access to Seedance 2.0",
  media: <SeedanceLogo />,
  href: "https://forms.gle/r9NrvJu6JGqeT5a36",
  target: "_blank",
} as const;
